// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Uxki","left":"styles_left__mJpWJ","desktopActions":"styles_desktopActions__bPt0w","title":"styles_title__1c34M"};